import { CdkTrapFocus } from "@angular/cdk/a11y";
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    Input,
    OnInit,
    Signal,
} from "@angular/core";
import { FormGroup } from "@angular/forms";

import {
    BeltkitProductAttributes,
    Product,
    ProductVariants,
} from "@hermes/api-model-product";

import {
    ProductPageFacade,
    ProductVariantType,
} from "@hermes/states/product-page";
import { skuToId } from "@hermes/utils-generic/helpers";

export interface VariantsList {
    name: ProductVariantType;
    pluralName: Extract<keyof ProductVariants, "buckles" | "leathers">;
    titleName: Extract<
        keyof BeltkitProductAttributes,
        "displayNameList" | "colorHermesLeather"
    >;
    colorName?: Extract<keyof BeltkitProductAttributes, "colorHermesBuckle">;
    tabTitle: string;
}

@Component({
    selector: "h-selector-top-layer",
    templateUrl: "./selector-top-layer.component.html",
    styleUrl: "./selector-top-layer.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    hostDirectives: [
        {
            directive: CdkTrapFocus,
            inputs: ["cdkTrapFocusAutoCapture: focus"],
        },
    ],
})
export class SelectorTopLayerComponent implements OnInit {
    @Input()
    public product!: Product;

    @Input()
    public variantsForm: FormGroup = new FormGroup({});

    public variantsList: VariantsList[] = [];

    public buckleTitle = $localize`:@@hermes-global-translations.buckle:buckle`;

    public tabVariantToSelect: Signal<number> = computed(() => {
        const topLayerContent =
            this.productPageFacade.topSelectorLayerContent();

        return this.variantsList.findIndex(
            (variant) => variant.name === topLayerContent?.variantType,
        );
    });

    public readonly imageAspectRatio = { width: 104, height: 104 };

    private readonly productPageFacade = inject(ProductPageFacade);

    public ngOnInit(): void {
        this.variantsList = [
            {
                name: "buckle",
                pluralName: "buckles",
                titleName: "displayNameList",
                colorName: "colorHermesBuckle",
                tabTitle: `${this.buckleTitle}`,
            },
            {
                name: "leather",
                pluralName: "leathers",
                titleName: "colorHermesLeather",
                tabTitle: `${this.product.attributes.colorHermesLabel}`,
            },
        ];
    }

    public close() {
        this.productPageFacade.showMoreVariantsRequested();
    }
    public getSkuToId(sku: string): string {
        return skuToId(sku ?? "");
    }
}
